/**
 * Module dependencies.
 */

import { AnimatedTypography } from '../animated-typography/animated-typography';
import { JSX, ReactNode } from 'react';
import { TypographyProps } from '@mui/material';

/**
 * `Props` type.
 */

type Props = TypographyProps & {
  children?: ReactNode;
  className?: string;
};

/**
 * Export `Description` component.
 */

export function Description(props: Props): JSX.Element {
  const { children, className, ...rest } = props;

  return (
    <AnimatedTypography
      className={className}
      component={'p'}
      variant={'body1'}
      {...rest}
    >
      {children}
    </AnimatedTypography>
  );
}
